module.exports = __webpack_public_path__ + "static/img/banner04.09ae25f5.png";